const AvatarIcon = ({ dimensions }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className={dimensions}
  >
    <rect width="24" height="24" fill="url(#avatar_gradient)" rx="12"></rect>
    <path
      fill="#fff"
      stroke="#fff"
      strokeWidth="1.829"
      d="M6.514 16.8c0-.197.092-.437.406-.727.32-.296.807-.579 1.418-.823 1.222-.49 2.706-.736 3.662-.736s2.44.246 3.662.736c.61.244 1.098.527 1.418.823.314.29.406.53.406.727a.686.686 0 01-.686.686H7.2a.686.686 0 01-.686-.686zm7.772-8A2.29 2.29 0 0112 11.086 2.29 2.29 0 019.714 8.8 2.29 2.29 0 0112 6.514 2.29 2.29 0 0114.286 8.8z"
    ></path>
    <defs>
      <linearGradient
        id="avatar_gradient"
        x1="0"
        x2="22.115"
        y1="11.999"
        y2="-2.875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B49EFF"></stop>
        <stop offset="1" stopColor="#00DAFA"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default AvatarIcon;
